import SceneProperties from '../../data/SceneProperties';
import PlatformTypeModel from '../../models/PlatformTypeModel';

type Props = {
    type: number,
    left: number,
    bottom: number,
    height: number,
    width: number,
    isHoriz: boolean,
    cover: boolean,
}

function Platform(props: Props) {
    let classPlatformName: string;

    switch (props.type) {
        case PlatformTypeModel.MOVING:
            classPlatformName = "movePlatform";
            break;
        case PlatformTypeModel.CRUSHER:
            classPlatformName = "crushPlatform";
            break;
        case PlatformTypeModel.DEBUG:
            classPlatformName = "debugPlatform";
            break;
        case PlatformTypeModel.BULLET:
            classPlatformName = "bullet";
            break;
        default:
            classPlatformName = "platform";
            if (!props.isHoriz) {
                classPlatformName += " vert";
            } else if (props.cover) {
                classPlatformName += " cover";
            }
            break;
    }

    let opacity = 1;

    if (classPlatformName === "bullet") {
        if (props.left > 0.75 * SceneProperties.bulletAmplitude) {
            let max = 0.35 * SceneProperties.bulletAmplitude;
            let offset = props.left - (0.75 * SceneProperties.bulletAmplitude);
            opacity = 1 - offset / max;
        }
    }

    return (
        <div className={classPlatformName} style={{
            left: `${props.left}px`,
            bottom: `${props.bottom}px`,
            height: `${props.height}px`,
            width: `${props.width}px`,
            opacity: `${opacity}`
        }}>
        </div>
    )
}

export default Platform
